import React, { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { nav, brand } from "../mock";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[#0a0a0b]/70 border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2">
          <span className="w-2.5 h-2.5 rounded-full bg-emerald-400 shadow-[0_0_20px_2px_rgba(16,185,129,0.6)]" />
          <span className="font-semibold tracking-[0.22em] text-sm text-white">{brand.name}</span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {nav.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-sm text-neutral-400 hover:text-white transition-colors relative group"
            >
              {n.label}
              <span className="absolute left-0 -bottom-1 h-px w-0 bg-emerald-400 transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a href="#contact" className="gt-btn-primary text-sm px-4 py-2 rounded-full inline-flex items-center gap-2">
            Book a Strategy Call <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        <button className="md:hidden text-white" onClick={() => setOpen((v) => !v)} aria-label="menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/5 bg-[#0a0a0b]/95 backdrop-blur-xl">
          <div className="px-6 py-4 flex flex-col gap-4">
            {nav.map((n) => (
              <a
                key={n.href}
                href={n.href}
                className="text-sm text-neutral-300 hover:text-emerald-400"
                onClick={() => setOpen(false)}
              >
                {n.label}
              </a>
            ))}
            <a href="#contact" onClick={() => setOpen(false)} className="gt-btn-primary text-sm px-4 py-2 rounded-full text-center">
              Book a Strategy Call
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
